export var PolyEventName = /* @__PURE__ */ ((PolyEventName2) => {
  PolyEventName2["POLY_PROGRESS"] = "POLYProgress";
  PolyEventName2["VIEWER_MOUNTED"] = "POLYViewerMounted";
  PolyEventName2["SCENE_READY"] = "POLYSceneReady";
  return PolyEventName2;
})(PolyEventName || {});
export class PolyEventsDispatcher {
  static dispatchProgressEvent(progress, sceneName) {
    const createEvent = (eventName) => {
      return new CustomEvent(eventName, {
        detail: {
          progress
        }
      });
    };
    document.dispatchEvent(createEvent("POLYProgress" /* POLY_PROGRESS */));
    document.dispatchEvent(createEvent(`${"POLYProgress" /* POLY_PROGRESS */}-${sceneName}`));
  }
}
